import type { Paginated, SyncStatusItem } from '@oxxean/types';
import type {
  SyncExecuteRequest,
  SyncExecuteResponse,
  SyncRun,
  SyncRunError,
} from '../../types/domain';
import type { TableState } from '../../hooks/useTableState';
import { http } from '../http';
import { tableStateToParams } from './params';

export async function fetchSyncStatus(): Promise<SyncStatusItem[]> {
  const response = await http.get<SyncStatusItem[]>('/sync/status');
  return response.data;
}

export async function fetchSyncRuns(state: TableState): Promise<Paginated<SyncRun>> {
  const response = await http.get<Paginated<SyncRun>>('/sync/runs', {
    params: tableStateToParams(state),
  });
  return response.data;
}

/** Los errores se listan íntegros: no se ocultan ni se agregan (§33). */
export async function fetchSyncRunErrors(
  runId: string,
  state: TableState,
): Promise<Paginated<SyncRunError>> {
  const response = await http.get<Paginated<SyncRunError>>(`/sync/runs/${runId}/errors`, {
    params: tableStateToParams(state),
  });
  return response.data;
}

export async function executeSync(payload: SyncExecuteRequest): Promise<SyncExecuteResponse> {
  const response = await http.post<SyncExecuteResponse>('/sync/run', payload);
  return response.data;
}
